import { render, staticRenderFns } from "./ModifyPhone.vue?vue&type=template&id=8467a816&"
import script from "./ModifyPhone.vue?vue&type=script&lang=js&"
export * from "./ModifyPhone.vue?vue&type=script&lang=js&"
import style0 from "./ModifyPhone.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ModifyPhone.vue"
export default component.exports